import gql from "graphql-tag";

export const CONNECT_MONDAY = gql`
  mutation ($input: connectMondayInput) {
    connectMonday(input: $input) {
      _id
    }
  }
`;
